import { useEffect, useState } from 'react';

/**
 * Vrati hodnotu az po delayMs bez dalsi zmeny. Zmena se pozna podle JSON obsahu,
 * ne podle reference - novy objekt se stejnym obsahem (prekresleni formulare)
 * casovac nerestartuje ani nevyvola dalsi dotaz.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState<T>(value);
    const klic = JSON.stringify(value);

    useEffect(() => {
        const casovac = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(casovac);
        // value je zachycena pres klic (JSON obsah); reference zamerne nevadi
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [klic, delayMs]);

    return debounced;
}
